export default {
  project: 'PROJECT'
};
